import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { REPORT_PRESET_TABS } from './reportPresetConstants';
import useCloneTracker from '../../../../../hooks/useCloneTracker';
import { useEffect, useRef } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const isReportValidForOriginalReportPreset = () => {
  return true;
};

/**
 * preset to transform report to most recent report state without any remix changes
 */
const OriginalReportPresetPill = ({
  appUsageTracker,
  report,
  onChange,
  selectedPresetId,
  setSelectedPresetId,
  isReportRemixChange
}) => {
  const originalReportRef = useRef(report);
  const tracker = useCloneTracker(appUsageTracker);
  useEffect(() => {
    if (!isReportRemixChange) {
      originalReportRef.current = report;
    }
  }, [report, isReportRemixChange]);
  return /*#__PURE__*/_jsx(AIButton, {
    usageTracker: tracker,
    use: selectedPresetId === REPORT_PRESET_TABS.DEFAULT ? 'primary' : 'secondary',
    size: "extra-small",
    onClick: () => {
      setSelectedPresetId(REPORT_PRESET_TABS.DEFAULT);
      onChange(originalReportRef.current, {
        isReportRemixChange: true
      });
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.singleReportViewer.AIReportSummary.reportRemixes.originalReport.button"
    })
  });
};
export default OriginalReportPresetPill;